import { Layout } from "../components/Layout";
import { RegisterForm } from "../components/RegisterForm";

export const Register = () => {
  return (
    <Layout title="Register your account">
      <RegisterForm />
    </Layout>
  );
};
